export * from './vertical-tabs-demo.component';
